import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { useRecoilState } from 'recoil';
import { checkEmptyValue, activeTabStyle, inActiveTabStyle, mmHgToKPa } from '../../plugins/common';
import { unitState, selectBedInfoState, measurementStateFamily, deviceModelInfo } from '../../plugins/recoil';
import { useBedData } from '../../context/BedDataContext';
import Dropdown from './components/Dropdown'
import axios from '../../plugins/axios'
import { useTranslation } from 'react-i18next';
import HalfMenus from '../../components/halfMenus';
import Toast from '../../plugins/useToast';

const Measurements = ({ onClose, onSetting, onTrend, onAlarmReview, handleSaveParameter }) => {
    const { t } = useTranslation()
    const [oldInfo, setOldInfo] = useState({})
    const [activeTab, ] = useState('nibp');
    const [activeMenu, setActiveMenu] = useState('main')
    const [isDisabled, setIsDisabled] = useState(true)
    const { getBedData, version } = useBedData()
    const bedData = getBedData()
    const [units] = useRecoilState(unitState)
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)
    const [nibpMeasureBtnDisabled, setNibpMeasureBtnDisabled] = useState(false)
    const [, setMeasurementSettings] = useRecoilState(measurementStateFamily(selectBedInfo?.serial || ''))
    const [deviceModelMenus, ] = useRecoilState(deviceModelInfo);
    const [nibpInterval, setNibpInterval] = useState({ label: 1, value: 1 })
    const isIntervalModifyRef = useRef();

    const [dropdownStates, setDropdownStates] = useState({
        ecgSpeed: false,
        respSpeed: false,
        spo2Speed: false,
        spo2Sat: false,
        nibpInterval: false,
        ibp1Label: false,
        ibp1Speed: false,
        ibp2Label: false,
        ibp2Speed: false,
        ibp3Label: false,
        ibp3Speed: false,
        ibp4Label: false,
        ibp4Speed: false,
        gasCo2Speed: false,
        gasAa1Speed: false,
        gasAa2Speed: false,
        gasO2Speed: false,
        gasN2oSpeed: false
      });

    const nibpValueArr = [
        { label: 'Off', value: 0 }, { label: 'Cont', value: -1 }, { label: 1, value: 60 }, { label: 2, value: 120 }, { label: 2.5, value: 150 },
        { label: 5, value: 300 }, { label: 10, value: 600 }, { label: 15, value: 900 }, { label: 30, value: 1800 },
        { label: 60, value: 3600 }, { label: 120, value: 7200 }
    ]

    const getData = async () => {
        try {
            // [GET] API
            const res = await axios.get(`/device/${selectBedInfo.deviceId}/measurement/nibp/settings`)
            if (res.code != '200') throw res
            setIsDisabled(true)
            setOldInfo({
                nibpInterval: res.data.intervalSeconds,
            })
            const intervalValue = res.data.intervalSeconds
            setNibpInterval(typeof intervalValue === 'number' ? 
                (nibpValueArr.find(item => item.value === intervalValue) || { label: 'Off', value: 0 }) : 
                { label: 'Off', value: 0 }
            )
            setMeasurementSettings(prev => ({
                ...prev,
                intervalSeconds: res.data.intervalSeconds
            }))
        } catch (err) { console.warn(err) }
    }

    const getNIBPDiff = () => {
        if (!bedData[selectBedInfo.serial]?.settingData?.lastBPMonth || !bedData[selectBedInfo.serial]?.settingData?.lastBPDay) return '---'
        const targetSettingData = bedData[selectBedInfo.serial]?.settingData
        let nibpTime = moment()
                        .set('month', targetSettingData.lastBPMonth - 1)
                        .set('date', targetSettingData.lastBPDay)
                        .set('hour', targetSettingData.lastBPHour)
                        .set('minute', targetSettingData.lastBPMinute)
                while(nibpTime.isAfter(moment())) {
                    nibpTime = nibpTime.subtract(1, 'year')
                }
                const diffTime = moment().diff(nibpTime)
        const duration = moment.duration(diffTime)
        const totalMinutes = Math.floor(duration.asMinutes())
        const hrs = Math.floor(totalMinutes / 60)
        const mins = totalMinutes % 60

        return `${hrs.toString().length > 1 ? hrs : '0' + hrs}:${mins.toString().length > 1 ? mins : '0' + mins}`
    }

    const toggleNIBPMeasure = async () => {
        try {
            const res = await axios.post(`/device/${selectBedInfo.deviceId}/measurement/nibp`)
            if (res.code != '200') throw res
            console.log(res)
        } catch (err) { console.warn(err) }
    }

    const handleSave = async () => {
        try {
            // [PUT] API
            const res = await axios.put(`/device/${selectBedInfo.deviceId}/measurement/nibp/settings`, {
                intervalSeconds: nibpInterval.value
            })
            if (res.code != '200') throw res
            setMeasurementSettings(prev => ({
                ...prev,
                intervalSeconds: nibpInterval.value,
            }))
            // oldInfo 세팅

            setOldInfo({
                nibpInterval: nibpInterval.value,
            })
            setIsDisabled(true)
            handleSaveParameter()
            Toast({ isSuccess: true });
        } catch (err) { console.warn(err) }
    }

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
          ...prev,
          [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    };

    const handleClickNIBPMeasure = () => {
        if (nibpMeasureBtnDisabled) return
        setNibpMeasureBtnDisabled(true)
        toggleNIBPMeasure()
        setTimeout(() => {
            setNibpMeasureBtnDisabled(false)
        }, 2000)
    }

    useEffect(() => {
        console.log('deviceModelMenus : ',deviceModelMenus);
        isIntervalModifyRef.current = deviceModelMenus.find(item => item.model === selectBedInfo.deviceModel)?.nibpIntervalModify;
        getData()        
    }, [selectBedInfo])

    useEffect(() => {
        if ( nibpInterval.value !== oldInfo.nibpInterval ) {
            setIsDisabled(false)
        } else {
            setIsDisabled(true)
        }
    }, [nibpInterval, oldInfo])

    return (
        <div className="wrapper relative w-full h-full bg-black max-h-[520px] font-normal border-t border-white">
            <div className="bg-[#1F1F1F] w-full h-full">
                <div className="flex relative justify-center text-white items-center h-[32px] bg-[#2C2C2C]">
                    <div className={`flex items-center px-2 py-1 bg-gradient-to-b ${'from-[#DEDEDE]'} ${'to-[#9F9F9F]'}`} style={{ height: '100%' }}>
                        <div className="flex items-center justify-center mr-2 text-black w-[178px]" style={{ fontWeight: 500, fontSize: 24, lineHeight: '26.4px' }}>{checkEmptyValue(selectBedInfo?.bedNumber.length <= 1 ? `0${selectBedInfo?.bedNumber}` : selectBedInfo?.bedNumber, 'BED-')}</div>                        
                        <div className="relative text-black truncate" style={{ fontWeight: 200, fontSize: 16, lineHeight: '17.6px', minWidth: 301, maxWidth: 301 }} title={ !selectBedInfo.patientId ? 'Not Admitted' : (selectBedInfo?.nameDisplay === '1' ? checkEmptyValue(selectBedInfo?.name) : selectBedInfo?.nameDisplay === '2' ? checkEmptyValue(selectBedInfo?.patientId) : selectBedInfo?.nameDisplay === '3' ? `${checkEmptyValue(selectBedInfo?.name)},${checkEmptyValue(selectBedInfo?.patientId)}`: '-')}>
                            { !selectBedInfo.patientId ? 'Not Admitted' : (selectBedInfo?.nameDisplay === '1' ? checkEmptyValue(selectBedInfo?.patientName) : selectBedInfo?.nameDisplay === '2' ? checkEmptyValue(selectBedInfo?.devicePatientId) : selectBedInfo?.nameDisplay === '3' ? `${checkEmptyValue(selectBedInfo?.patientName)} , ${checkEmptyValue(selectBedInfo?.devicePatientId)}`: '-')}
                        </div>
                    </div>
                    <HalfMenus 
                        selectBedInfo={selectBedInfo}
                        nowPage={'measurements'}
                        onTrend={onTrend}
                        onAlarmReview={onAlarmReview}
                        onMeasurements={null}
                        onSetting={onSetting}
                        isFull={null}
                        isFromSearch={false}
                        handleFullScreen={null}
                        onClose={onClose}
                    />
                </div>
                <div className="flex justify-between bg-black h-[36px]">
                    <div className='flex gap-1 pt-1 text-lg' />
                    <div className="flex items-center gap-[8px] mr-[20px]">
                        <button className={`w-[88px] h-[28px] font-light relative rounded-[6px] ${isDisabled? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none' : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'} active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`} disabled={isDisabled} onClick={() => {handleSave()}}>{isDisabled ? t('measurement.saved') : t('measurement.save')}</button>                
                    </div>
                </div>
                <div className="text-white flex" style={{ height: 'calc(100% - 72px)' }}>
                    {
                        activeTab === 'nibp' &&
                        <>
                            {
                                activeMenu === 'main' &&
                                <>
                                    <div className="px-10 py-5">
                                        <div className="" style={{ fontSize: 18 }}>{t('measurement.nibpMeasurement')}</div>
                                        <div className="mt-4">
                                            <div className="font-light mb-1 opacity-70 text-white">{t('measurement.startStop')}</div>
                                            <div onClick={() => { handleClickNIBPMeasure() }} className="w-[256px] h-[32px] flex items-center justify-center" style={{ cursor: nibpMeasureBtnDisabled ? 'default' : 'pointer',opacity: nibpMeasureBtnDisabled ? 0.4 : 1, borderRadius: 6, background: 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)', border: '1px solid #5E5E5E', boxShadow: '0px 4px 4px 0px #00000066' }}>{bedData[selectBedInfo.serial]?.settingData?.pressureStatus ? t('measurement.stop') : t('measurement.start')}</div>
                                        </div>                                        
                                        <div className="mt-5">
                                            <div className="font-light mb-1 opacity-70 text-white">{t('measurement.autoInterval')}</div>
                                            <Dropdown 
                                                unit={nibpInterval.value ? 'min' : ''}
                                                type={'nibp-interval'}
                                                isShow={dropdownStates.nibpInterval}
                                                value={nibpInterval}
                                                valueArr={nibpValueArr}
                                                handleClick={(val) => { handleClickDropdown('nibpInterval', val) }}
                                                handleValueClick={(val) => { setNibpInterval(val) }}
                                                disabled={!isIntervalModifyRef.current}
                                            />
                                        </div>
                                        <div className="mt-5">
                                            <div className="font-light mb-1 opacity-70 text-white">{t('measurement.measurementTime')}</div>
                                            <div className="flex items-center w-[256px] h-[32px] bg-[#2C2C2C80]" style={{ borderRadius: 6 }}>{`${getNIBPDiff()} (${nibpInterval.value > 0 ? nibpInterval.label + 'min' : nibpInterval.value < 0 ? 'Cont' : 'Off'})`}</div>
                                        </div>
                                        <div className="mt-5 flex">
                                            <div className="">
                                                <div className="font-light mb-1 opacity-70 text-white">SYS</div>
                                                <div className="flex items-center justify-center w-[80px] h-[32px] bg-[#2C2C2C80]" style={{ borderRadius: 6 }}>{units['NIBP'] === 'mmHg' ? bedData[selectBedInfo.serial]?.numericData?.nibpSysValue : mmHgToKPa(bedData[selectBedInfo.serial]?.numericData?.nibpSysValue)}</div>
                                            </div>
                                            <div className="ml-2">
                                                <div className="font-light mb-1 opacity-70 text-white">DIA</div>
                                                <div className="flex items-center justify-center w-[80px] h-[32px] bg-[#2C2C2C80]" style={{ borderRadius: 6 }}>{units['NIBP'] === 'mmHg' ? bedData[selectBedInfo.serial]?.numericData?.nibpDiaValue : mmHgToKPa(bedData[selectBedInfo.serial]?.numericData?.nibpDiaValue)}</div>
                                            </div>
                                            <div className="ml-2">
                                                <div className="font-light mb-1 opacity-70 text-white">MAP</div>
                                                <div className="flex items-center justify-center w-[80px] h-[32px] bg-[#2C2C2C80]" style={{ borderRadius: 6 }}>{units['NIBP'] === 'mmHg' ? bedData[selectBedInfo.serial]?.numericData?.nibpMapValue : mmHgToKPa(bedData[selectBedInfo.serial]?.numericData?.nibpMapValue)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default Measurements